import { ReactComponent as ImplantIcon } from 'assets/contents/implant.svg';
import { ReactComponent as ImplantsAndContentsIcon } from 'assets/contents/implantsAndInstruments.svg';
import { ReactComponent as InstrumentIcon } from 'assets/contents/instrument.svg';
import { ReactComponent as UnknownIcon } from 'assets/contents/unknown.svg';
import { DeliveryContent } from 'api/models/Deliveries';
import { useLanguage } from 'context/AppContext';

export const useContentsConfig = (contents: DeliveryContent, showNotSpecifiedText = true) => {
  const lang = useLanguage()[0].DeliveryContent;
  const label = !showNotSpecifiedText && contents == DeliveryContent.Default ? '' : lang[contents];

  switch (contents) {
    case DeliveryContent.Instruments:
      return {
        label,
        Icon: InstrumentIcon,
      };
    case DeliveryContent.Implants:
      return {
        label,
        Icon: ImplantIcon,
      };
    case DeliveryContent.InstrumentsAndImplants:
      return {
        label,
        Icon: ImplantsAndContentsIcon,
      };
    default:
      return {
        label,
        Icon: UnknownIcon,
      };
  }
};
